const DEFAULT_EXIMBAY_SDK_URL =
  'https://api-test.eximbay.com/v2/javascriptSDK.js';

const sdkPromises = new Map();

// Priority: URL sent by our backend (always matches the environment that issued
// the fgkey) > build-time env override > public sandbox.
const resolveSdkUrl = (sdkUrl) =>
  sdkUrl || process.env.REACT_APP_EXIMBAY_SDK_URL || DEFAULT_EXIMBAY_SDK_URL;

const findLoadedScript = (src) =>
  Array.from(document.querySelectorAll('script[data-eximbay-sdk]')).find(
    (script) => script.src === src
  );

export const loadEximbaySdk = (sdkUrl) => {
  const src = resolveSdkUrl(sdkUrl);
  if (window.EXIMBAY?.request_pay && findLoadedScript(src)) {
    return Promise.resolve(window.EXIMBAY);
  }
  if (sdkPromises.has(src)) return sdkPromises.get(src);

  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.dataset.eximbaySdk = 'true';
    script.src = src;
    script.async = true;
    script.onload = () =>
      window.EXIMBAY?.request_pay
        ? resolve(window.EXIMBAY)
        : reject(new Error('Eximbay SDK did not initialize.'));
    script.onerror = () => {
      sdkPromises.delete(src);
      script.remove();
      reject(new Error('Could not load Eximbay SDK.'));
    };
    document.head.appendChild(script);
  });
  sdkPromises.set(src, promise);
  return promise;
};

/**
 * `sdkUrl` is added by our backend and is not part of Eximbay's request schema,
 * so it is used to pick the SDK and stripped before request_pay.
 */
export const requestEximbayPayment = async (request) => {
  const { sdkUrl, ...payload } = request;
  const eximbay = await loadEximbaySdk(sdkUrl);
  eximbay.request_pay(payload);
};
